module.exports = __webpack_public_path__ + "img/NewsCenter_pic2.7ff450fb.png";